<script setup lang="ts">
const props = defineProps({
  project: { type: Object, required: true },
  industry: { type: Object, required: false },
})

const localePath = useLocalePath()

const path = computed(() => {
  if (props.industry) {
    return `/projects/${props.industry[0]}/${props.project.slug}`
  }

  return `/projects/${props.project.slug}`
})
</script>

<template>
  <article class="project px-2">
    <div class="project-content md:mt-0">
      <div class="project-image">
        <div class="bordershadow-medium relative aspect-video rounded-lg bg-white p-2">
          <NuxtImg
            v-if="project.image"
            :src="project.image.url"
            :alt="`Preview image for ${project.image.name}`"
            :width="project.image.width"
            :height="project.image.height"
            class="bordershadow-gray h-full w-full rounded object-cover"
            fit="cover"
          />

          <div
            v-if="project.country_flag"
            :title="project.country_name"
            class="absolute right-4 top-4 rounded-full bg-white px-2 py-1 shadow-sm"
          >
            <Icon :name="project.country_flag || ''" />
          </div>
        </div>
      </div>

      <div class="mt-6">
        <p class="text-gray-500">
          {{ project.industries.join(', ') }}
        </p>

        <Heading size="medium" class="text-main-950 mb-4">
          {{ props.project.title }}
        </Heading>

        <Paragraph size="normal" class="text-gray-700">
          {{ props.project.description }}
        </Paragraph>

        <nuxt-link :to="localePath(path)" class="text-main-600 group flex items-center py-3 font-bold">
          {{ $t('common.see_how_it_works') }}
          <Icon name="lucide:move-right" size="18" class="ml-2 transition group-hover:translate-x-1" />
        </nuxt-link>
      </div>
    </div>
  </article>
</template>

<style lang="postcss" scoped></style>
